import Tokens from "@/components/ui/services/TokenService";

const fields = {
    id: null,
    email: '',
    phone: null,
    role: {name: ''},
    first_name: '',
    last_name: '',
    patronymic: '',
}

export default api => {
    return {
        namespaced: true,
        state: {...fields},
        getters: {
            isLoggedIn: state => state.id > 0,
            //checkRole: state => allowedRoles => state.user !== null && allowedRoles.some(role => state.user.roles.includes(role)),
            name: state => state.first_name + ' ' + state.last_name,
            role: state => state.role.name,
            //isAdmin: state => state.user.role.id === 1,
            isAdmin: () => localStorage.getItem('role') === 'admin',
            id: state => state.id,
            requiredName: (state, getters) => {
                return !(state.first_name && state.last_name) && getters.isLoggedIn
            },

        },
        mutations: {
            setUser(state, user) {
                for (let key in fields)
                    state[key] = user[key]
            },
            clear(state) {
                for (let key in fields)
                    state[key] = fields[key]
            },
        },
        actions: {
            init({commit}) {
                const user = Tokens.getUser()
                if (user) {
                    commit('setUser', user)
                }

                console.log('❗ init account переделать')
            },

            init_login({dispatch, commit}, {user, accessToken, schools}) {
                dispatch('push', user)
                Tokens.updateLocalAccessToken(accessToken)
                localStorage.setItem(Tokens.STORAGE_KEY + '_schools', JSON.stringify(schools))
                commit('school/setSchools', schools, {root: true})
            },

            push({commit}, user) {
                Tokens.setUser(user)
                commit('setUser', user);
            },

            async update({state, dispatch}, fields) {
                const user = await api.update(state.id, fields)
                dispatch('push', user)
                return user
            },

            async login({dispatch}, {email, password}) {
                let {user, accessToken, schools} = await api.login(email, password);
                dispatch('init_login', {user, accessToken, schools});
                return user;
            },

            async store({dispatch}, {email, password, captcha}) {
                let {user, accessToken, schools} = await api.store(email, password, captcha);
                dispatch('init_login', {user, accessToken, schools});
                return user;
            },

            async logout({commit}) {
                Tokens.clean();
                commit('clear');

            },
        }
    }
}